import React from 'react';

export default function Terms() {
  return (
    <section id="terms" className="py-24 px-6 relative">
      <div className="liquid-glass max-w-xl mx-auto rounded-3xl p-10 text-center">
        <h2 className="font-instrument italic text-white text-3xl">
          "No surprises. Ever."
        </h2>
        
        <div className="mt-8 space-y-4 font-sans text-left max-w-sm mx-auto">
          <p className="text-white/70 text-base flex leading-snug">
            <span className="mr-3 text-white/40">&mdash;</span> 
            You own the final files upon full payment
          </p>
          <p className="text-white/70 text-base flex leading-snug">
            <span className="mr-3 text-white/40">&mdash;</span> 
            50% deposit to book &middot; 50% before final delivery
          </p>
          <p className="text-white/70 text-base flex leading-snug">
            <span className="mr-3 text-white/40">&mdash;</span> 
            Fixed pricing &middot; what you see is what you pay
          </p>
          <p className="text-white/70 text-base flex leading-snug">
            <span className="mr-3 text-white/40">&mdash;</span> 
            2 revisions included &middot; additional at $150 each
          </p>
        </div>
        
        <p className="text-white/30 text-xs mt-10 font-sans leading-relaxed">
          Base package includes Amazon listing rights.<br className="hidden sm:block" />
          Social and ad licensing available as add-ons.
        </p>
      </div>
    </section>
  );
}